export default "__VITE_ASSET__CcEfznji__"